import React, { useEffect, useMemo, useState } from 'react';

import { Button, Col, Drawer, Form, Input, Modal, Row, Select } from 'antd';
import { useDispatch } from 'react-redux';

import { ChevronDown, ChevronUp, CloseIcon, UsFlag } from '../../../../assets/icons';
import FloatingLabel from '../../../../components/FloatingLabel/FloatingLabel';
import EmailField from '../../../../components/SharedComponents/FormComponents/EmailField';
import SuccessModal from '../../../../components/SuccessModal/SuccessModal';

import { resendEmailAndPhoneCode, updateEmailAndPhone, verifyEmailAndPhoneCode } from '../../../../services/AccountApi/profileApi';
import { getUserProfileApi } from '../../../../services/authApi/userApi';
import { addCounter, addUserData, changePersonalDetails, falseEmailVerifyed } from '../../../../store/reducer/accountSlice';

import useMediaQuery from '../../../../Hooks/useMediaQuery';
import { formatePhoneNumber } from '../../../../utils/formatPhoneNumber';
import { toastNotify } from '../../../../utils/toastNotify';
import ReqNameChange from './ReqNameChange';
// import { phoneRegex } from '../../../../utils/Validations';

const EditAccDetails = (props) => {
  const [email, setEmail] = useState();
  const [countryCode, setCountryCode] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [successOpen, setSuccessOpen] = useState(false);
  const [reqOpen, setReqOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [verificationCodeEmail, setVerificationCodeEmail] = useState(null);
  const [verificationCodePhone, setVerificationCodePhone] = useState(null);
  const [arrowUp, setArrowUp] = useState(false);
  const [countDown, setCountDown] = useState(0);
  const [isShowResend, setShowResend] = useState(false);
  const screenMD = useMediaQuery('(min-width: 1000px)');

  // const [verifyEmail, setVerifyEmail] = useState(false);
  // const [verifyPhone, setVerifyPhone] = useState(false);
  const [verifyBoth, setVerifyBoth] = useState(false);
  const [updatedData, setUpdatedData] = useState({}); //tempory use state

  const [openVerifyModal, setOpenVerifyModal] = useState({
    verifyEmail: false,
    verifyPhone: false,
  });
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { userProfileData } = props;

  useEffect(() => {
    handleSetDefaultValue();
  }, [userProfileData]);

  const handleSetDefaultValue = () => {
    if (Object.keys(userProfileData).length > 0) {
      let { email, phoneNumber } = userProfileData;
      form.setFieldsValue({
        email: email,
        phoneNumber: formatePhoneNumber(phoneNumber),
      });
      setEmail(email);
      setPhoneNumber(formatePhoneNumber(phoneNumber));
      setEdit(true);
    }
  };

  const isEmailChangeSubmitFisabled = useMemo(() => {
    let { email: userEmail, phoneNumber: userPhoneNumber } = userProfileData;
    return email === userEmail && phoneNumber === formatePhoneNumber(userPhoneNumber);
  }, [userProfileData, email, phoneNumber]);

  const handleChangeNumber = (e) => {
    const { value } = e.target;
    const phoneNumber = formatePhoneNumber(value);
    form.setFieldsValue({ phoneNumber: phoneNumber });
    setPhoneNumber(phoneNumber);
  };
  const onAccDetailsSubmit = async (values) => {
    setLoading(true);
    const { phoneNumber, email } = values;
    //convert formate number into normal number (xxxx)-xx-xxx to xxxxxx"
    const phoneNumberInp = `${phoneNumber.slice(1, 4)}${phoneNumber.slice(6, 9)}${phoneNumber.slice(10, 14)}`;
    const accountData = {
      email: email,
      phoneNumber: phoneNumberInp,
      countryCode: '+1',
    };
    if (phoneNumber === '(000) 000-0000') {
      setLoading(false);
      toastNotify('error', 'Enter a valid phone number.');
    } else {
      try {
        const resp = await updateEmailAndPhone(accountData);
        if (!resp.isError) {
          const { data } = resp;
          timerCounter();
          setUpdatedData({
            email: email,
            phoneNumber: phoneNumberInp,
          });
          dispatch(
            changePersonalDetails({
              email: email,
              phoneNumber: phoneNumberInp,
            })
          );
          props.setEditModal(false);
          setOpenVerifyModal({
            verifyEmail: data?.isEmailModified,
            verifyPhone: data?.isPhoneNumberModified,
          });
          if (data?.isEmailModified) {
            await dispatch(falseEmailVerifyed());
          }
          if (data?.isEmailModified && data?.isPhoneNumberModified) {
            setVerifyBoth(true);
          }
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleVerifyEmail = async () => {
    if (verificationCodeEmail?.length !== 6) {
      toastNotify('error', 'The code must be 6 digits long.');
      return;
    }

    setLoading(true);
    const emailVerificationData = {
      code: parseInt(verificationCodeEmail),
      type: 0, //used enum type 0 forEMAIL_PIN
    };
    try {
      const resp = await verifyEmailAndPhoneCode(emailVerificationData);
      if (!resp.isError) {
        if (openVerifyModal.verifyEmail && openVerifyModal.verifyPhone) {
          setVerifyBoth(false);
        } else {
          setVerificationCodeEmail('');
          handleVerifyEmialClosed();
          setSuccessOpen(true);
          //tempory fix for update
          dispatch(changePersonalDetails(updatedData));
          form.resetFields(['verificationCodeEmail']);
        }
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyNumber = async () => {
    setLoading(true);
    const phoneVerificationData = {
      code: parseInt(verificationCodePhone),
      type: 1, //used enum type 1 for SMS_PIN
    };
    try {
      const resp = await verifyEmailAndPhoneCode(phoneVerificationData);
      if (!resp.isError) {
        setVerifyBoth(false);
        handleVerifyPhoneClosed();
        setSuccessOpen(true);
        //tempory fix for update
        dispatch(changePersonalDetails(updatedData));
        form.resetFields(['verificationCodePhone']);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyEmialClosed = () => {
    setOpenVerifyModal({
      verifyEmail: false,
    });
    form.resetFields(['verificationCodeEmail']);
    getUserProfile();
  };
  // get profile data when verify modal closed
  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();
      if (!resData.isError) {
        const { data } = resData;
        dispatch(addUserData({ userData: data?.user }));
        dispatch(addCounter(data?.counter));
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleVerifyPhoneClosed = () => {
    setOpenVerifyModal({
      verifyPhone: false,
    });
    setVerifyBoth(false);
    form.resetFields(['verificationCodePhone']);
    getUserProfile();
  };
  const resendEmailAndNumberCode = async (resendType) => {
    setResendLoading(true);
    const type = resendType;
    try {
      const resp = await resendEmailAndPhoneCode({ type });
      if (!resp.isError) {
        timerCounter();
        toastNotify('success', resp?.message);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setResendLoading(false);
    }
  };

  const timerCounter = (timerValue = 30) => {
    setShowResend(true);
    let timeleft = timerValue;
    const downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setCountDown(0);
        setShowResend(false);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  };

  // const userPhoneNumber = formatePhoneNumber(userProfileData?.phoneNumber);
  // const userEmail = userProfileData?.email;
  return (
    <>
      <Modal
        className='account__modal'
        open={props.setOpen}
        onCancel={() => {
          handleSetDefaultValue();
          props.setEditModal(false);
        }}
        width={524}
        footer={false}
        closeIcon={<CloseIcon />}
        centered
      >
        <h4 className='mb-32 account__modal__title'>Edit personal account details</h4>
        <div className='editacc'>
          <p className='mb-4 subhead-1'>
            {userProfileData.firstName} {userProfileData.lastName}
          </p>
          <p className='text-muted'>
            Need to change your legal name?{' '}
            <span
              className='text-copper cursor-pointer'
              onClick={() => {
                props.setEditModal(false);
                setReqOpen(true);
              }}
            >
              Start here
            </span>
          </p>
          <Form name='editAccDeatails' form={form} onFinish={onAccDetailsSubmit} autoComplete='off' initialValues={{ countryCode: '+1' }}>
            <FloatingLabel label='Email' inputId='email' inputValue={email} isEdit={isEdit}>
              <EmailField email={email} setEmail={(value) => setEmail(value)} />
            </FloatingLabel>
            <Row gutter={[24]}>
              <Col span={24} sm={9}>
                <FloatingLabel label='Country Code' inputId='countryCode' inputValue={countryCode} isEdit={isEdit}>
                  <>
                    <div id='country-code-anchor' />
                    <Form.Item name='countryCode'>
                      <Select
                        id='countryCode'
                        onChange={(value) => setCountryCode(value)}
                        // value={countryCode}
                        getPopupContainer={() => document.getElementById('country-code-anchor')}
                        onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
                        suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                        disabled
                      >
                        <Select.Option value='+1'>
                          <UsFlag marginRight='10px' verticalAlign='middle' top='-2px' />
                          US +1
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </>
                </FloatingLabel>
              </Col>
              <Col span={24} sm={15} className='mb-24'>
                <FloatingLabel label='Phone Number' inputId='phoneNumber' inputValue={phoneNumber} isEdit={isEdit}>
                  <Form.Item
                    validateTrigger='onBlur'
                    name='phoneNumber'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter phone number',
                      },
                    ]}
                  >
                    <Input
                      id='phoneNumber'
                      type='tel'
                      value={phoneNumber}
                      // onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder='(XXX) XXX-XXXX'
                      onChange={(e) => handleChangeNumber(e)}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </FloatingLabel>
              </Col>
              <Col span={12}>
                <Form.Item className='mb-0'>
                  <Button
                    onClick={() => {
                      handleSetDefaultValue();
                      props.setEditModal(false);
                    }}
                    className='w-100'
                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item className='mb-0' shouldUpdate>
                  {() => (
                    <Button
                      className='w-100'
                      type='primary'
                      htmlType='submit'
                      // onClick={() => {
                      //   props.setClose();
                      //   setSuccessOpen(true);
                      // }}
                      loading={loading}
                      disabled={
                        isEmailChangeSubmitFisabled ||
                        phoneNumber?.length < 14 ||
                        !!form.getFieldsError().filter(({ errors }) => errors.length).length
                      }
                    >
                      Save
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      {screenMD ? (
        <Modal
          open={openVerifyModal.verifyEmail}
          onCancel={() => {
            handleVerifyEmialClosed();
          }}
          width={526}
          footer={false}
          closeIcon={<CloseIcon />}
          centered
        >
          <h4 className='mb-16 account__modal__title'>Verify email</h4>
          <p className='mb-30'>
            We have sent a verification code to <span className='fw-600'>{email}</span>. Please enter the code below to verify your email.
          </p>
          <Form
            form={form}
            onKeyPress={(e) => {
              if (verificationCodeEmail && e.key === 'Enter') {
                handleVerifyEmail();
              }
            }}
          >
            <FloatingLabel className='mb-48' label='Verification code' inputId='verificationCodeEmail' inputValue={verificationCodeEmail}>
              <Form.Item name='verificationCodeEmail'>
                <Input
                  id='verificationCodeEmail'
                  value={verificationCodeEmail}
                  onChange={(e) => setVerificationCodeEmail(e.target.value)}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </FloatingLabel>
            <Row gutter={[16, 16]}>
              <Col span={24} sm={12}>
                <Button
                  disabled={isShowResend}
                  loading={resendLoading}
                  className='w-100 px-0'
                  onClick={() => resendEmailAndNumberCode(0)} //used enum type 0 for EMAIL_PIN
                >
                  Resend code
                  {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
                </Button>
              </Col>
              <Col span={24} sm={12}>
                <Button
                  type='primary'
                  className='w-100'
                  onClick={() => handleVerifyEmail()}
                  loading={loading}
                  disabled={verificationCodeEmail && verificationCodeEmail?.length === 6 ? false : true}
                >
                  {verifyBoth ? 'Continue' : 'Verify'}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      ) : (
        <Drawer
          className='footer-shadow quickbuy--drawer'
          open={openVerifyModal.verifyEmail}
          onClose={() => {
            handleVerifyEmialClosed();
          }}
          width='100%'
          closeIcon={<CloseIcon />}
          centered
          title={<p className='subhead-2 mb-0 ml-40 text-center'>Verify email</p>}
          footer={
            <Row gutter={[16, 16]}>
              <Col span={24} sm={12}>
                <Button
                  disabled={isShowResend}
                  loading={resendLoading}
                  className='w-100 px-0'
                  onClick={() => resendEmailAndNumberCode(0)} //used enum type 0 for EMAIL_PIN
                >
                  Resend code
                  {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
                </Button>
              </Col>
              <Col span={24} sm={12}>
                <Button
                  type='primary'
                  className='w-100'
                  onClick={() => handleVerifyEmail()}
                  loading={loading}
                  disabled={verificationCodeEmail && verificationCodeEmail?.length === 6 ? false : true}
                >
                  {verifyBoth ? 'Continue' : 'Verify'}
                </Button>
              </Col>
            </Row>
          }
        >
          <p className='mb-30'>
            We have sent a verification code to <span className='fw-600'>{email}</span>. Please enter the code below to verify your email.
          </p>
          <Form
            form={form}
            onKeyPress={(e) => {
              if (verificationCodeEmail && e.key === 'Enter') {
                handleVerifyEmail();
              }
            }}
          >
            <FloatingLabel className='mb-48' label='Verification code' inputId='verificationCodeEmail' inputValue={verificationCodeEmail}>
              <Form.Item name='verificationCodeEmail'>
                <Input
                  id='verificationCodeEmail'
                  value={verificationCodeEmail}
                  onChange={(e) => setVerificationCodeEmail(e.target.value)}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </FloatingLabel>
          </Form>
        </Drawer>
      )}
      {screenMD ? (
        <Modal
          open={openVerifyModal.verifyPhone && !verifyBoth}
          onCancel={() => {
            setVerifyBoth(false);
            handleVerifyPhoneClosed();
          }}
          width={526}
          footer={false}
          closeIcon={<CloseIcon />}
          centered
        >
          <h4 className='mb-32 account__modal__title'>Verify phone number</h4>
          <p>
            We have sent a verification code to <span className='fw-600'>+1 {phoneNumber}</span>. Please enter the code below to verify your phone
            number.
          </p>
          <Form form={form}>
            <FloatingLabel className='mb-48' label='Verification code' inputId='verificationCodePhone' inputValue={verificationCodePhone}>
              <Form.Item name='verificationCodePhone'>
                <Input
                  id='verificationCodePhone'
                  value={verificationCodePhone}
                  onChange={(e) => setVerificationCodePhone(e.target.value)}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </FloatingLabel>
            <Row gutter={[16, 16]}>
              <Col span={24} sm={12}>
                <Button
                  disabled={isShowResend}
                  loading={resendLoading}
                  className='w-100 px-0'
                  onClick={() => resendEmailAndNumberCode(1)} //used enum type 1 for SMS_PIN
                >
                  Resend code
                  {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
                </Button>
              </Col>
              <Col span={24} sm={12}>
                <Button
                  type='primary'
                  className='w-100'
                  loading={loading}
                  onClick={() => handleVerifyNumber()}
                  disabled={verificationCodePhone && verificationCodePhone?.length === 6 ? false : true}
                >
                  Verify
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      ) : (
        <Drawer
          className='footer-shadow quickbuy--drawer'
          open={openVerifyModal.verifyPhone && !verifyBoth}
          onClose={() => {
            setVerifyBoth(false);
            handleVerifyPhoneClosed();
          }}
          width={526}
          title={<h4 className='subhead-2 mb-0 ml-40 text-center'>Verify phone number</h4>}
          footer={
            <Row gutter={16}>
              <Col span={24}>
                <Button
                  disabled={isShowResend}
                  loading={resendLoading}
                  className='w-100 mb-16'
                  onClick={() => resendEmailAndNumberCode(1)} //used enum type 1 for SMS_PIN
                >
                  Resend code
                  {countDown > 0 && <span className='ml-4'>in {<span>{`${countDown}`}</span>}s</span>}
                </Button>
              </Col>
              <Col span={24} sm={12}>
                <Button
                  type='primary'
                  className='w-100 mb-16'
                  loading={loading}
                  onClick={() => handleVerifyNumber()}
                  disabled={verificationCodePhone && verificationCodePhone?.length === 6 ? false : true}
                >
                  Verify
                </Button>
              </Col>
            </Row>
          }
          closeIcon={<CloseIcon />}
          centered
        >
          <p className='mb-30 text-taupe'>
            We have sent a verification code to <span className='fw-600 text-almost-black'>+1 {phoneNumber}</span>. Please enter the code below to
            verify your phone number.
          </p>
          <Form form={form}>
            <FloatingLabel className='mb-48' label='Verification code' inputId='verificationCodePhone' inputValue={verificationCodePhone}>
              <Form.Item name='verificationCodePhone'>
                <Input
                  id='verificationCodePhone'
                  value={verificationCodePhone}
                  onChange={(e) => setVerificationCodePhone(e.target.value)}
                  maxLength={6}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </FloatingLabel>
          </Form>
        </Drawer>
      )}
      <SuccessModal
        setOpen={successOpen}
        setClose={() => setSuccessOpen(false)}
        setDone={() => {
          setSuccessOpen(false);
        }}
      />
      <ReqNameChange setOpen={reqOpen} setClose={() => setReqOpen(false)} setBackModal={() => props.setEditModal(true)} />
    </>
  );
};

export default EditAccDetails;
